import { z } from "zod";

import { ExperienceDtoSchema } from "./experiences";

export const ExperienceListDtoSchema = ExperienceDtoSchema.extend({
  previewPath: z.string(),
});
export type ExperienceListDto = z.infer<typeof ExperienceListDtoSchema>;
